/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取空中写号申请列表
export function listWriteCardApply(params) {
    return request({
        url: 'writeCardApplyList/list.do?',
        method: 'post',
        data: params
    })
}

// 导出空中写号申请列表
export function exportWriteCardApply(params) {
    return request({
        url: 'writeCardApplyList/export.do?',
        method: 'post',
        data: params
    })
}

// 根据ID删除空中写号申请
export function deleteById(params) {
    return request({
        url: 'writeCardApplyList/delete.do?',
        method: 'post',
        data: params
    })
}

// 批量导入空中写号申请
export function importExcel(params) {
    return request({
        url: 'writeCardApplyList/batchImport.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量删除空中写号申请
export function batchDelete(params) {
    return request({
        url: 'writeCardApplyList/batchDelete.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 写卡接口
export function writeCard(params) {
    return request({
        url: 'writeCardApplyList/writeCard.do?',
        method: 'post',
        data: params
    })
}

// 编辑卡接口
export function editCard(params) {
    return request({
        url: 'writeCardApplyList/update.do?',
        method: 'post',
        data: params
    })
} 


// 虚拟卡详情 写卡接口
export function writeCardOne(params) {
    return request({
        url: 'writeCardApplyList/writeCardByProvince.do?',
        method: 'post',
        data: params
    })
}